import axios, { AxiosResponse } from 'axios';
import { loginApis, htmlApis } from '../../../common/apis';
import { FetchCaptchaRequestVO, LoginRequestVO } from '../typing';

export const getUserAgreement = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.get(htmlApis.userAgreement).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};

export const getPrivacyStrategy = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.get(htmlApis.privacyStrategy).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};

export const fetchCaptcha = (fetchCaptchaRequestVO: FetchCaptchaRequestVO): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(loginApis.fetchCaptcha, fetchCaptchaRequestVO).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};

export const loginPyxis = (loginRequestVO: LoginRequestVO): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(loginApis.loginPysix, loginRequestVO).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};

export const getUserInfo = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    axios.post(loginApis.getUserInfo).then(
      (res: AxiosResponse<any>) => {
        resolve(res.data);
      },
      err => {
        reject(err);
      },
    );
  });
};
